import { Field, Input } from '@fluentui/react-components';
import { useT } from '../../i18n';
import type { AddEventInput } from '../../api/traceability.api';

type CoolingForm = Pick<AddEventInput,
  'coolingLocation' | 'coolingDate' | 'recipientLocation' | 'referenceDocType' | 'referenceDocNumber' | 'product' | 'variety'>;

/** Campos de enfriado (FSMA 204). El padre solo los muestra con fsma.enabled y tipo COOLING. */
export function CoolingKdeFields({ form, onChange }: { form: CoolingForm; onChange: (patch: Partial<CoolingForm>) => void }) {
  const t = useT();
  const l = t.traceability.kdeFields;
  const text = (key: keyof CoolingForm, label: string, type: 'text' | 'date' = 'text') => (
    <Field label={label} key={key}>
      <Input type={type} value={form[key] ?? ''} onChange={(_, d) => onChange({ [key]: d.value })} />
    </Field>
  );
  return (
    <>
      {text('coolingLocation', l.coolingLocation)}
      {text('coolingDate', l.coolingDate, 'date')}
      {text('product', l.product)}
      {text('recipientLocation', l.recipientLocation)}
      {text('referenceDocType', l.referenceDocType)}
      {text('referenceDocNumber', l.referenceDocNumber)}
    </>
  );
}
